
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as xtaAlQvLVyyMp_452DC8HEj_vsd_OW0EUM9w5SRbxjc5XLk8Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/xta.vue?macro=true";
import { default as bqfgqAovUflQOgTf6SdSicK1EUs39nyO5xZT7hQOE2Q7m_wMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/bqfg.vue?macro=true";
import { default as feesazm83GJV5G8JzbOpLn3j8OmQPESOFEt8zfcxxNXZ_l8Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/fees.vue?macro=true";
import { default as index3zaZJz9cGdofdb_45bAUGpSLHKXmJXfI56zHeUB03xXHwMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/index.vue?macro=true";
import { default as imprinty083G4TL7AphD4DZfNwDjrmqhLp79sTHZNkDNpEYU8oMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BW/pages/imprint.vue?macro=true";
import { default as privacytY3RMnW4sg8DUYaCboYQGFedSl_4Bku8cv6e19kkUqYMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BW/pages/privacy.vue?macro=true";
import { default as requestqDjUAQfoz6Lnotcf1S5lAm9NKmX4VHPVQ5k3QfsYBTMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request.vue?macro=true";
import { default as dashboardaGQ27S5DPiCzCafKoRYae_lbYAT33uh5g09tI_45jorRIMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/dashboard.vue?macro=true";
import { default as templates1cIHx7fs4k8b9IiU45qvFYxcrZT_gYXtVtOF_2eDD5IMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/templates.vue?macro=true";
import { default as request_45ah173LFaDt9hBDrxrHsa6xYeLa6QNW_45cIVZ90QQRU1lhsMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request-ah.vue?macro=true";
import { default as request_45pugKk3V5Nwe0D3r30Rl_45PL_45S3YSDD4BLkyRGYxW5HQO6nMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request-pug.vue?macro=true";
import { default as exam_45signupseGGbTvajaYUY_3ZPUPl38mj_45aAHI1rBvjoBmitDyJecMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/exam-signups.vue?macro=true";
import { default as register64tsQqza187gkY1K2MBTrVXkGeTGgYgXNO76v0jKl3AMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/register.vue?macro=true";
import { default as organisationsjdghnwU3C_45FlFvDasbtnFHqBl72m_opQXfeHIjDnQXoMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisations.vue?macro=true";
import { default as indexJSwnPEfBLTbE2Gu3WDLMvRSogTt2eS7fds8bz6wUKmsMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/profile/index.vue?macro=true";
import { default as _91id_93bCasjSUCM5_jp7_452_45JFlPhg3XueeJWRKP_459ruBv8SXwMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/operation/[id].vue?macro=true";
import { default as logged_45outL35j_45gSIy_45ntnMbPXQNtJXIHJbxBnVyuz_SEHF61L_454Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/logged-out.vue?macro=true";
import { default as ahZj5dnDNCF_458_f4_5CvEAahbmfeeXs__45x6YemRrIT6AkMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah.vue?macro=true";
import { default as pugwC85VbU2BZFs_45IDfAKdbNLlsSbWAWSxedt2Z5zjhZPgMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug.vue?macro=true";
import { default as _91id_93KWQF9mK9cq6a_45pSmVbvtHGBaRct1OcRmTkqNGrBpmPgMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisation/[id].vue?macro=true";
import { default as password_45resetSEpk_45sqHbe7lFaoQeiHs_45yip1NNBPZlVc8bVTX2DsdMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/password-reset.vue?macro=true";
import { default as ah_45allBnt9rnqPQcOMPbiCIhnroOQ_45Pjm9OyBc6o_45RM2OLcHMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-all.vue?macro=true";
import { default as email_45confirmedV_454ZcdtxpUbbEBOaoehXrmN6F_45EWL6vNGHicg6D7cDQMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/email-confirmed.vue?macro=true";
import { default as forgot_45passwordm1fHTy_4pd_45wtfbjU_euu6c5LDkaE_AyE4l85CtZwc8Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/forgot-password.vue?macro=true";
import { default as forgot_45usernameqHU0MfqV6wFWiRH5nzyow1_45gio9STkUBww6tykQ39toMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/forgot-username.vue?macro=true";
import { default as ah_45donevDLauXc_45PjIYh9Gvpfx9m38__V54dUIKsoo_45w2ShpyEMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-done.vue?macro=true";
import { default as pug_45alluMnIVAbW1PDW_45cHm9wBqQCd4y3Grd6LlxHolrarfGUMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-all.vue?macro=true";
import { default as pug_45doneDH2rhtz4tKxGb2ZO6sGjqX3_dI2kDZnJQHwFwVciDOAMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-done.vue?macro=true";
import { default as accessibility_45statementtKZ4ur9O2X_45mqcMxffuWMBdTNDTA5JHpukFcX3_45rVhMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/accessibility-statement.vue?macro=true";
import { default as _91id_93rRzQGRa47AvRgIy0kaqmh6rr8mPaX7HZK4O5451NrNMMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisation/person/[id].vue?macro=true";
import { default as warning_45fileob8WXwCFn3RqpUdZPQfD8DnyBRSjnxYpSq5ge7JvzfkMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/warning-file.vue?macro=true";
import { default as requests_458lYPpkMV3xMVuoiUM0nemdWrGToNJefHOFDl9Ciiy8Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/generic-workflow/requests.vue?macro=true";
import { default as _91id_93kS8IZGY_c_45PPj6C_LtuotkTgsFp5LA1_uiIv7xFSc74Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/reference-profession/[id].vue?macro=true";
import { default as workflowsaMp76mdZ8v0Y1vFLIYfhbLrSNNz6xk69yuhG3CqtgNgMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/generic-workflow/workflows.vue?macro=true";
import { default as ah_45in_45progressGGt3iu9xQMDxoYnspmHJMprjCCp1RzfwI714R8ekoGoMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-in-progress.vue?macro=true";
import { default as pug_45in_45progressDCLlaZHn1cIVQ0Yzdacd6w9YRlUMRmvlLCQfaNcAykUMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-in-progress.vue?macro=true";
import { default as _91id_93_45Ji3yVyyaDlRoy_45VWjcUMRJvpRsQUvpqgekV_oXbzV0Meta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/operation/edit-base-data/[id].vue?macro=true";
import { default as ah_45document_45number0ihcvxwYnEZvgo7A7NrT9_aIPCBVQtb5Z85RqqOWG2kMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-document-number.vue?macro=true";
import { default as reference_45professionskjRsMrlYLJptsLlALwT2j_45QG8TGwX3ysrXoiaRrI5gAMeta } from "/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/reference-professions.vue?macro=true";
export default [
  {
    name: "xta",
    path: "/xta",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/xta.vue")
  },
  {
    name: "bqfg",
    path: "/bqfg",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/bqfg.vue")
  },
  {
    name: "fees",
    path: "/fees",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/fees.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/index.vue")
  },
  {
    name: "imprint",
    path: "/imprint",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BW/pages/imprint.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BW/pages/privacy.vue")
  },
  {
    name: "request",
    path: "/request",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/dashboard.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/templates.vue")
  },
  {
    name: "request-ah",
    path: "/request-ah",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request-ah.vue")
  },
  {
    name: "request-pug",
    path: "/request-pug",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/request-pug.vue")
  },
  {
    name: "exam-signups",
    path: "/exam-signups",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/exam-signups.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/register.vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: {"middleware":["auth-guard","organisation-admin-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisations.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/profile/index.vue")
  },
  {
    name: "operation-id",
    path: "/operation/:id()",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/operation/[id].vue")
  },
  {
    name: "auth-logged-out",
    path: "/auth/logged-out",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/logged-out.vue")
  },
  {
    name: "data-browser-ah",
    path: "/data-browser/ah",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah.vue")
  },
  {
    name: "data-browser-pug",
    path: "/data-browser/pug",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug.vue")
  },
  {
    name: "organisation-id",
    path: "/organisation/:id()",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisation/[id].vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password-reset",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/password-reset.vue")
  },
  {
    name: "data-browser-ah-all",
    path: "/data-browser/ah-all",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-all.vue")
  },
  {
    name: "auth-email-confirmed",
    path: "/auth/email-confirmed",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/email-confirmed.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-username",
    path: "/auth/forgot-username",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/auth/forgot-username.vue")
  },
  {
    name: "data-browser-ah-done",
    path: "/data-browser/ah-done",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-done.vue")
  },
  {
    name: "data-browser-pug-all",
    path: "/data-browser/pug-all",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-all.vue")
  },
  {
    name: "data-browser-pug-done",
    path: "/data-browser/pug-done",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-done.vue")
  },
  {
    name: "accessibility-statement",
    path: "/accessibility-statement",
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "organisation-person-id",
    path: "/organisation/person/:id()",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/organisation/person/[id].vue")
  },
  {
    name: "data-browser-warning-file",
    path: "/data-browser/warning-file",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/warning-file.vue")
  },
  {
    name: "generic-workflow-requests",
    path: "/generic-workflow/requests",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/generic-workflow/requests.vue")
  },
  {
    name: "reference-profession-id",
    path: "/reference-profession/:id()",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/reference-profession/[id].vue")
  },
  {
    name: "generic-workflow-workflows",
    path: "/generic-workflow/workflows",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/pages/generic-workflow/workflows.vue")
  },
  {
    name: "data-browser-ah-in-progress",
    path: "/data-browser/ah-in-progress",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-in-progress.vue")
  },
  {
    name: "data-browser-pug-in-progress",
    path: "/data-browser/pug-in-progress",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/pug-in-progress.vue")
  },
  {
    name: "operation-edit-base-data-id",
    path: "/operation/edit-base-data/:id()",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/operation/edit-base-data/[id].vue")
  },
  {
    name: "data-browser-ah-document-number",
    path: "/data-browser/ah-document-number",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/ah-document-number.vue")
  },
  {
    name: "data-browser-reference-professions",
    path: "/data-browser/reference-professions",
    meta: {"middleware":["auth-guard"]},
    component: () => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/pages/data-browser/reference-professions.vue")
  }
]